<div>
  <nav class="d-flex flex-row bg-white rounded-4 justify-content-between p-2 shadow-sm my-2 navbar navbar-expand-lg">
    {{roleUserLogged}}
    <div class="col mx-2 collapse navbar-collapse justify-content-end" id="navbarNav">

      <ul class="navbar-nav">

        <li class="nav-item" *ngIf="roleUserLogged == 'RETAILER'">
          <a class="nav-link" href="#">
            <b>Marketplace R2W</b>
            <span>{{total_r2w}}</span>
          </a>
        </li>
        <li class="nav-item" *ngIf="roleUserLogged == 'RETAILER'">
          <a class="nav-link" href="#">
            <b>Marketplace Brand</b>
            <span>{{total_brand}}</span>
          </a>
        </li>

        <li  #dropdownProfile class="nav-item d-flex position-relative">
          <a class="nav-link fw-bold" (click)="showDropdownProfile = !showDropdownProfile">
            <img src="assets/img/smile.jpg" class="img-fluid me-1 object-fit-cover rounded-circle" width="42"
              alt="user">
            {{userLogged}}
          </a>

          <div id="dropdownProfile" class="position-absolute p-2 bg-white shadow rounded top-100 end-0 z-3" [hidden]="!showDropdownProfile" >
            <ul class="list-group list-group-flush">
              <p class="fw-bold mb-0">Benvenuto!</p>
              <a routerLink="/profile" class="list-group-item list-group-item-action" (click)="showDropdownProfile = false">
                <i class="bi bi-gear"></i>
                Impostazioni
              </a>
              <a href="#" class="list-group-item list-group-item-action" (click)="logout()" (click)="showDropdownProfile = false">
                <i class="bi bi-box-arrow-right"></i>
                Logout
              </a>
            </ul>
          </div>

        </li>
      </ul>
    </div>
  </nav>
</div>
